
        // Expose ELEVENLABS agent id via meta tag and window for robust loading
        (function(){
            const agentId = import.meta?.env?.VITE_ELEVENLABS_AGENT_ID;
            if (agentId) {
                let m = document.querySelector('meta[name="elevenlabs-agent-id"]');
                if (!m) {
                    m = document.createElement('meta');
                    m.setAttribute('name', 'elevenlabs-agent-id');
                    document.head.appendChild(m);
                }
                m.setAttribute('content', agentId);
                window.ELEVENLABS_AGENT_ID = agentId;
            }
        })();
        console.log('Starting Breaking Good application...');
        
        // Enhanced error handling
        let initializationTimeout;
        let hasLoaded = false;
        
        // Global error handler
        window.addEventListener('error', (event) => {
            console.error('Global error:', event.error);
            showError('JavaScript Error', event.error?.message || 'Unknown error');
        });
        
        window.addEventListener('unhandledrejection', (event) => {
            console.error('Unhandled promise rejection:', event.reason);
            showError('Promise Rejection', event.reason?.message || 'Unknown promise error');
        });
        
        function showError(title, details) {
            if (hasLoaded) return; // Don't show startup errors after app loads
            
            const loadingScreen = document.getElementById('loadingScreen');
            const errorScreen = document.getElementById('errorScreen');
            const errorDetails = document.getElementById('errorDetails');
            
            loadingScreen.classList.add('hidden');
            errorScreen.classList.remove('hidden');
            errorDetails.textContent = `${title}: ${details}`;
            
            clearTimeout(initializationTimeout);
        }
        
        function hideLoadingScreen() {
            hasLoaded = true;
            const loadingScreen = document.getElementById('loadingScreen');
            const appContainer = document.getElementById('appContainer');
            
            loadingScreen.style.display = 'none';
            appContainer.style.display = 'block';
            
            clearTimeout(initializationTimeout);
        }
        
        // Set a timeout for initialization
        initializationTimeout = setTimeout(() => {
            if (!hasLoaded) {
                showError('Initialization Timeout', 'App failed to load within 10 seconds. This might be a network or module loading issue.');
            }
        }, 10000);
        
        // Test environment variables immediately
        console.log('Testing environment variables...');
        const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
        const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;
        
        if (!supabaseUrl || !supabaseKey) {
            showError('Configuration Error', 'Missing Supabase environment variables. Check .env file.');
        } else {
            console.log('Environment variables loaded successfully');
            console.log('Supabase URL:', supabaseUrl);
        }
        
        // Async initialization to handle module imports and app setup
        (async function initializeApp() {
            try {
                console.log('Attempting to import modules...');
                
                // Import modules with error handling
                const { supabase } = await import('./credentials.js');
                console.log('Credentials module imported');
                
                const { MedicationTracker } = await import('./modules/app-core.js');
                console.log('App core module imported');
                
                // Test Supabase connection
                console.log('Testing Supabase connection...');
                const { data: healthCheck, error: healthError } = await supabase.from('medications').select('count', { count: 'exact', head: true });
                
                if (healthError) {
                    console.warn('Supabase health check failed:', healthError);
                    // Don't fail completely, just log the warning
                } else {
                    console.log('Supabase connection successful');
                }
                
                // Make supabase globally available
                window.supabaseClient = supabase;
                window.supabase = supabase;
                
                // Initialize the app
                console.log('Initializing MedicationTracker...');
                const app = new MedicationTracker();
                
                // Make app globally accessible
                window.medicationTracker = app;
                
                // Initialize the app
                await app.init();
                
                console.log('App initialization completed successfully');
                hideLoadingScreen();
                
            } catch (error) {
                console.error('Failed to initialize app:', error);
                showError('Module Loading Error', error.message + '\n\nStack: ' + (error.stack || 'No stack trace'));
            }
        })();
    